export const GAME_STATUS = {
  1: 'Not Started',
  2: 'In Progress',
  3: 'Paused',
  4: 'Finished',
};

export enum TGameStatus {
  NOT_STARTED = 1,
  IN_PROGRESS = 2,
  PAUSED = 3,
  FINISHED = 4,
}

export const PLAY_RESULT_TYPES = {
  1: 'Turnover',
  2: 'First Down',
  3: 'Touchdown',
  4: 'Field Goal Made',
  5: 'Extra Point Made',
  6: 'Two-point Conversion',
  7: 'Safety',
  8: 'Penalty (home)',
  9: 'Penalty (away)',
  10: 'Penalty (both)',
  11: 'Pass Incomplete',
  12: 'Pass Complete',
  13: 'Sack',
  14: 'Interception',
  15: 'Fumble',
  16: 'Fumble Lost',
  17: 'Rush Attempt',
  18: 'One-Point Safety',
  19: 'Touchback',
  20: 'PAT Missed',
  21: 'FG Missed',
  22: '2-Point Return',
  23: 'Pass Complete, Touchdown',
  24: 'Pass Complete, Safety',
  25: 'Pass Complete, Fumble Lost',
  26: 'Pass Complete, Fumble Lost, Touchdown',
  27: 'Sack, Safety',
  28: 'Sack, Fumble Lost',
  29: 'Sack, Fumble Lost, Touchdown',
  30: 'Interception, Touchdown',
  31: 'Fumble Lost, Touchdown',
  32: 'Rush Attempt, Touchdown',
  33: 'Rush Attempt, Safety',
  34: 'Rush Attempt, Fumble Lost',
  35: 'Rush Attempt, Fumble Lost, Touchdown',
  36: 'FG Missed, Touchdown',
  37: 'Penalty (declined)',
};

export enum TPlayResultTypes {
  TOV = 1,
  FIRST_DOWN = 2,
  TD = 3,
  FG = 4,
  EXTRA_PT = 5,
  CONVERSION_2PT = 6,
  SAFTEY = 7,
  PENALTY_HOME = 8,
  PENALTY_AWAY = 9,
  PENALTY_BOTH = 10,
  PASS_INCOMP = 11,
  PASS_COMP = 12,
  SACK = 13,
  INTERCEPTION = 14,
  FUMBLE = 15,
  FUMBLE_LOST = 16,
  RUSH_ATTENPT = 17,
  SAFTEY_1PT = 18,
  TOUCHBACK = 19,
  PAT_MISS = 20,
  FG_MISS = 21,
  TWO_PT_RETURN = 22,
  PASS_COMP_TD = 23,
  PASS_COMP_SAFETY = 24,
  PASS_COMP_FUMBLE_LOST = 25,
  PASS_COMP_FUMBLE_LOST_TD = 26,
  SACK_SAFETY = 27,
  SACK_FUMBLE_LOST = 28,
  SACK_FUMBLE_LOST_TD = 29,
  INTERCEPTION_TD = 30,
  FUMBLE_LOST_TD = 31,
  RUSH_ATTEMPT_TD = 32,
  RUSH_ATTEMPT_SAFETY = 33,
  RUSH_ATTEMPT_FUMBLE_LOST = 34,
  RUSH_ATTEMPT_FUMBLE_LOST_TD = 35,
  FG_MISS_TD = 36,
  PENALTY_DECLINED = 37,
}

export const REF_EVENT_OUTCOMES = {
  1: 'Penalty',
  2: 'Review',
  3: 'Challenge',
  4: 'Measurement',
};

export enum TRefEventOutcomes {
  PENALTY = 1,
  REVIEW = 2,
  CHALLENGE = 3,
  MEASUREMENT = 4,
}

export const QUARTER_DISPLAY_STRING = {
  1: 'Q1',
  2: 'Q2',
  3: 'Q3',
  4: 'Q4',
  5: 'OT1',
  6: 'OT2',
  7: 'OT3+',
};

export enum TQuarters {
  Q1 = 1,
  Q2 = 2,
  Q3 = 3,
  Q4 = 4,
  OT1 = 5,
  OT2 = 6,
  OT3_PLUS = 7,
}

export const EVENT_TYPES = {
  1: 'Ball Snapped',
  2: 'Potential Turnover',
  3: 'Potential Scoring Play',
  4: 'Unexpected QB Appearance',
  5: 'Weather Change',
  6: 'Formation',
  7: 'Price Danger',
  8: 'Starters Pulled',
  9: 'Significant Player Injury',
  10: 'Revision',
  11: 'Definite First Down',
  12: 'Play Under Review',
  13: 'Coin Toss Winning Team Is Home',
  14: 'Coin Toss Winner Is Kicking',
  15: 'Overturned',
  16: 'Play Design',
  17: 'Ref Event In Progress',
  18: 'Kickoff Kicked',
  19: 'Preliminary Yards To Goal Line',
  20: 'Close But Cannot Confirm 1st Down',
  21: 'Is Offense Coming On Field',
  22: 'Expected QB Has Returned',
  23: 'Incomplete Pass',
  24: 'Timeout Started',
  25: 'Official Timeout Selected',
  26: 'Timeout Canceled',
  27: 'Injury Player',
};

export enum TEventTypes {
  BALL_SNAP = 1,
  POTENTIAL_TOV = 2,
  POTENTIAL_SCORE = 3,
  UNEXPECTED_QB = 4,
  WEATHER = 5,
  FORMATION = 6, // depreciated in favor of PLAY_DESIGN
  PRICE_DANGER = 7,
  STARTERS_PULLED = 8,
  INJURY = 9,
  REVISION = 10,
  FIRST_DOWN = 11,
  UNDER_REVIEW = 12,
  COIN_TOSS_HOME_WIN = 13,
  WINNER_KICKING = 14,
  OVERTURNED = 15,
  PLAY_DESIGN = 16,
  REF_EVENT = 17,
  KICKOFF_KICKED = 18,
  PRELIMINARY_YARDS_TO_GOAL_LINE = 19,
  CLOSE_1ST = 20,
  OFFENSE_COMING_ON = 21,
  QB_RETURNED = 22,
  INCOMPLETE_PASS = 23,
  TIMEOUT_STARTED = 24,
  OFFICIAL_TIMEOUT = 25,
  TIMEOUT_CANCELED = 26,
  INJURY_PLAYER = 27,
}

export const PLAY_DESIGNS: { [key: number]: string } = {
  1: 'Pass',
  2: 'Rush',
  3: 'Kickoff',
  4: 'Punt',
  5: 'Field goal',
  6: 'Extra point',
  7: 'Onside Kick',
  8: 'Two Point Attempt',
  9: 'No Play',
};

export enum TPlayDesigns {
  PASS = 1,
  RUSH = 2,
  KICKOFF = 3,
  PUNT = 4,
  FG = 5,
  EXTRA_PT = 6,
  ONSIDE = 7,
  TWO_PT_CONVERSION = 8,
  NO_PLAY = 9,
}

export const PLAYER_ROLE: { [key: number]: string } = {
  1: 'Passer',
  2: 'Receiver',
  3: 'Rusher',
};

export enum TPlayerRole {
  PASSER = 1,
  RECEIVER = 2,
  RUSHER = 3,
}

export const USER_ROLES = ['ALL', 'CLOCK', 'PLAYS'];
